import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberPathForCheckoutLeave } from '../hooks/useMobCheckoutLeaveConfirm';

/** Tracks route changes so checkout leave can navigate to a known destination. */
export function CheckoutPathTracker() {
  const location = useLocation();

  useEffect(() => {
    rememberPathForCheckoutLeave(location.pathname);
  }, [location.pathname]);

  return null;
}
